document.addEventListener('DOMContentLoaded', () => {
  let cartReady = false

  if (!customElements.get('gift-box-checkbox')) {
    customElements.define('gift-box-checkbox', class GiftBoxCheckbox extends HTMLElement {
      constructor() {
        super()

        this.computeProductInCart()

        this.querySelector('#gift-box-checkbox').addEventListener('click', event => {
          if (!this.giftBoxInCart)
            document.querySelector('gift-box-panel').classList.add('is-open')
          else {
            this.noteVariantId = Number(this.getAttribute('data-note-id'))
            this.boxVariantId = Number(this.getAttribute('data-gift-id'))

            CartJS.setAttribute('gift-note', '')
            if (this.boxVariantId) {
              CartJS.removeItemById(this.boxVariantId)
            }

            this.querySelector('#gift-box-checkbox').classList.add('free-gift-loading')

            this.resetGiftCheck()
          }
        })

        this.querySelectorAll(['#tick-text']).forEach(item => item.addEventListener('click', () => {
          document.querySelector('gift-box-panel').classList.add('is-open')
        }))
      }

      resetGiftCheck() {
        document.querySelector('gift-box-checkbox #add-gift-box-product span').innerHTML = "ADD"
        document.querySelector('gift-box-checkbox #tick-text').innerHTML = this.getAttribute('data-text')
        document.querySelector('gift-box-checkbox').classList.remove('activegift')
        document.querySelector('#add-gift-box-product').classList.add('disabled')
        $(document).on('cart.requestComplete', this.doUpdate)
      }

      productId = 0
      variantId = 0
      giftBoxInCart = false

      doUpdate() {
        $(document).off('cart.requestComplete', this.doUpdate)
      }

      computeProductInCart() {
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        const cart = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.productId) {
          for (const item of cart.items) {
            if (item.product_id === this.productId) {
              this.giftBoxInCart = true
            }
          }
        } else {
          this.giftBoxInCart = !!cart.attributes['gift-note']
        }

        if (this.giftBoxInCart) {
          this.classList.add('activegift')
        } else if (cart.attributes['gift-note']) {
          CartJS.setAttribute('gift-note', '')
        }
      }
    })
  }

  if (!customElements.get('gift-box-panel')) {
    customElements.define('gift-box-panel', class GiftBoxPanel extends HTMLElement {
      constructor() {
        super()
        this.productId = Number(this.getAttribute('data-gift-product-id'))
        this.variantId = Number(this.getAttribute('data-gift-id'))

        const input = this.querySelector('textarea')
        const maxLength = 200

        this.querySelector('.giftnote-remaining-text span').innerHTML = maxLength - String(input.value).length
        input.addEventListener('keydown', (e) => {
          this.querySelector('.giftnote-remaining-text span').innerHTML = maxLength - String(input.value).length
        })

        setTimeout(() => {
          this.style.display = "flex"
        }, 500);

        const cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.computeProductInCart(cartJson)

        this.querySelectorAll(['.mini-cart-giftnote__top--icon', '.btn--giftnote--cancel']).forEach(item => item.addEventListener('click', () => {
          this.classList.remove('is-open')
        }))

        this.defaultText = document.querySelector('#add-gift-box-product span').innerHTML

        document.querySelector('#gift-note').addEventListener('keydown', () => {
          if (document.querySelector('#gift-note').value)
            document.querySelector('.btn--giftnote').classList.remove('disabled')
          else
            document.querySelector('.btn--giftnote').classList.add('disabled')
        })

        this.querySelector('#add-gift-box-product').addEventListener('click', (event) => {
          let target = ''
          if (event.target.id === 'add-gift-box-product') {
            target = event.target
          } else {
            target= event.target.closest('#order-save')
          }

          if (target.classList.contains('disabled')) {
            return
          }

          if (!this.giftBoxInCart) {
            if (this.variantId)  {
              CartJS.addItems([
                {id: this.variantId},
              ])
            }
            this.giftBoxInCart = true
          }
          CartJS.setAttribute('gift-note', this.querySelector('#gift-note').value)

          target.classList.add('free-gift-loading')
          $(document).on('cart.requestComplete', this.updateStatus.bind(this))
        })
      }

      updateStatus() {
        this.classList.remove('is-open')
        document.querySelector('#add-gift-box-product span').innerHTML = "Save"
        this.querySelector('#add-gift-box-product').classList.remove('free-gift-loading')

        $(document).off('cart.requestComplete', this.updateStatus)
      }

      productId = 0
      variantId = 0
      defaultText = ''
      giftBoxInCart = false

      computeProductInCart(cart) {
        if (cart.attributes["gift-note"]) {
          this.classList.add('activegift')
          this.giftBoxInCart = true
        }

        if (this.giftBoxInCart && cart.attributes["gift-note"]) {
          document.querySelector('#gift-note').value = cart.attributes["gift-note"] || ''
          this.querySelector('.giftnote-remaining-text span').innerHTML = 200 - cart.attributes["gift-note"].length
          document.querySelector('#add-gift-box-product span').innerHTML = "UPDATE"
          if (cart.attributes["gift-note"])
            document.querySelector('#add-gift-box-product').classList.remove('disabled')
        } else {
          document.querySelector('#gift-note').value = ''
        }

        const rate = Number(window.Shopify.currency.rate)
        const giftBoxAmount = Number(this.getAttribute('data-free-amount')) * rate

        if (cart.total_price >= giftBoxAmount) {
          document.querySelector('#add-gift-box-product span').innerHTML = this.giftBoxInCart && cart.attributes['gift-note'] ? "UPDATE" : 'ADD'
        }
      }
    })
  }


})
